import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

export const PayerDetails = (props) => {
    const [currentPayer, changePayer] = useState(null);
    const [currentPayerSentence, updatesentence] = useState(null);   

    function displayThirdPartyInfo(){
        if(currentPayer == "other"){
            return (
                <div id="Payer-Info-Card" className="col-sm-12 col-md-6 mt-3">
                    <div className="card border border-dark p-2">
                        <div className="display-5 mb-2">Payer details</div>
                        <div className="row">
                            <div className="col-md-12 col-sm-9">
                                <label className="control-label">Full Name</label>                
                                <input required name="Payer.FullName" className="form-control" autoComplete="name"/>
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">Email Address</label>
                                <input required name="Payer.emailAddress" className="form-control" autoComplete="email"/>
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">Phone Number</label>
                                <input required name="Payer.phoneNumber" className="form-control" autoComplete="home tel"/>
                            </div>
                            <div className="col-md-6 col-sm-8 mt-sm-2">
                                <label className="control-label">Company Name</label>
                                <input name="Payer.companyName" className="form-control"/>
                            </div>
                        </div>
                    </div>
                </div>  
            )
        }
        return null;
    }
    
    return(
        <div className="col-12 my-2">
            <hr />
            <div className="row">
                <div className="col-12 mb-1">
                    <strong>Please select the payer for this freight</strong>
                </div>
                <div className="col-12 mb-1">
                    <em>{currentPayerSentence}</em>
                </div>
                <br />
                <div className="col-12 mb-1">
                    <div className="form-check form-check-inline ml-2 mb-1">
                        <input type="radio" className="form-check-input"
                            id="Payer-Is-Self" name="PayerType"
                            value="self"
                            onClick={() => {
                                props.changeWhoPayerIs("self"); 
                                changePayer("self");
                                updatesentence(<span>You are paying for this freight</span>)
                            }}/>
                        <label className="form-check-label" htmlFor="Payer-Is-Self">
                            Self
                        </label>
                    </div>

                    <div className="form-check form-check-inline ml-2 mb-1">
                        <input type="radio" className="form-check-input"
                            id="Payer-Is-Consignee" name="PayerType"
                            value="consignee" 
                            onClick={() => { 
                                props.changeWhoPayerIs("consignee"); 
                                changePayer("consignee");
                                updatesentence(<span>The consignee is paying for this freight</span>);
                            }}/>
                            
                        <label className="form-check-label" htmlFor="Payer-Is-Consignee">
                            Consignee
                        </label>
                    </div>

                    <div className="form-check form-check-inline ml-2 mb-1">
                        <input type="radio" className="form-check-input"
                            id="Payer-Is-Other" name="PayerType"
                            value="other"
                            onClick={() => {
                                props.changeWhoPayerIs("other");
                                changePayer("other");      
                                updatesentence(<span>A third party is paying for this freight</span>);
                            }}/>
                            
                        <label className="form-check-label" htmlFor="Payer-Is-Other">
                            Other
                        </label>
                    </div>     
                </div>
                {displayThirdPartyInfo()}
            </div>
        </div>
    );
}